import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  margin-top: 90px;
  padding: 32px 35px 122px;
  
  border-top: 1px solid #E7E8FC88;
`
